export default __webpack_public_path__ + "static/media/socialInstagram.c326175b.svg";